// Banner de mensaje (alert success/warning/error/info) basado en
// data.message del kc_data. Mantiene la convención Bootstrap 3 del
// legacy (alert / alert-danger / alert-success / etc.) para reproducir
// el look — el mapping `error → danger` es el mismo que hacía el
// bundle anterior.

import type { KcDataMessage } from "../kcData";

export interface MessageProps {
  message?: KcDataMessage;
}

export function Message({ message }: MessageProps) {
  if (!message?.summary) {
    return (
      <div id="kc-feedback-placeholder">
        <div id="kc-feedback-placeholder-wrapper" />
      </div>
    );
  }

  const cssType = message.type === "error" ? "danger" : message.type;
  return (
    <div className={`alert alert-${cssType}`}>
      <span dangerouslySetInnerHTML={{ __html: message.summary }} />
    </div>
  );
}
